import React from "react";
import { withStyles} from "@material-ui/core";
import {Select,FormControl,InputLabel} from '@material-ui/core';
import PropTypes from "prop-types";
import cx from "classnames";
import Clear from "@material-ui/icons/Clear"
import Check from "@material-ui/icons/Check"

import customInputStyle from "../../assets/jss/material-dashboard-react/customInputStyle";
class CustomSelect extends React.Component{


    state ={
        selectedOption: ""

    }

    handleChange = event => {
        this.setState({ selectedOption: event.target.value });
        if(this.props.onChange){
            this.props.onChange(event.target.value)
        }

    };


    render(){

        const {
            labelText,
            options,
            formControlProps,
            classes,
            id,
            error,
            success} = this.props

        const marginTop = cx({
            [classes.marginTop]: labelText === undefined
        });

        const labelClasses = cx({
            [" " + classes.labelRootError]: error,
            [" " + classes.labelRootSuccess]: success && !error
        });



        return(
            <FormControl {...formControlProps} className={formControlProps.className + " " + classes.formControl}>
                <InputLabel className={classes.labelRoot + labelClasses} htmlFor={id}>{labelText}</InputLabel>
                <Select
                    native
                    value={this.state.selectedOption.value}
                    onChange={this.handleChange}
                    inputProps={{
                        id: {id},
                    }}
                    classes={{
                        root: marginTop,
                        disabled: classes.disabled,
                    }}
                >


                    <option value=""/>

                    {options?
                        options.map((option,index)=> {
                            return <option value={option.value} key={index}>{option.text}</option>
                        }):null
                    }
                </Select>
                {error ? (
                    <Clear className={classes.feedback + " " + classes.labelRootError} />
                ) : success ? (
                    <Check className={classes.feedback + " " + classes.labelRootSuccess} />
                ) : null}
            </FormControl>
        )



    }






}



const styles={




}



export default withStyles(customInputStyle)(CustomSelect);


// WEBPACK FOOTER //
// ./src/components/CustomSelect/CustomSelect.jsx